export default () => {
  const { $t } = useNuxtApp()

  const transportationLabels: { [key: number]: string } = {
    0: $t('labels.nonContainerTruck'),
    1: $t('labels.containerTruck')
  }

  const transportationTypeKeys = [0, 1]

  const transportationOptions = () => {
    const results = [] as { [key: string]: any }[]

    transportationTypeKeys.forEach((key) => {
      results.push({
        value: key,
        label: transportationLabels[key] ?? ''
      })
    })

    return results
  }
  const contTypes = [
    {
      value: 20,
      label: $t('labels.vehicleModule.20ft')
    },
    {
      value: 40,
      label: $t('labels.vehicleModule.40ft')
    },
    {
      value: 45,
      label: $t('labels.vehicleModule.45ft')
    }
  ]

  const taskTypes = [
    {
      key: 'AFFECT_SHIPPING_TIME',
      label: $t('labels.task')
    },
    {
      key: 'NO_AFFECT_SHIPPING_TIME',
      label: $t('labels.job')
    }
  ]

  const timeConditionTypes = [
    {
      key: 'START',
      label: $t('labels.start')
    },
    {
      key: 'END',
      label: $t('labels.end')
    }
  ]

  const timeConditionTimeTypes = [
    {
      key: 'EARLIEST',
      label: $t('labels.earliest')
    },
    {
      key: 'LATEST',
      label: $t('labels.latest')
    }
    // {
    //   key: 'PERMANENT',
    //   label: $t('labels.permanent')
    // }
  ]

  return {
    transportationLabels,
    transportationTypeKeys,
    transportationOptions,
    contTypes,
    taskTypes,
    timeConditionTypes,
    timeConditionTimeTypes
  }
}
